import { ContentSection, Heading } from '@cinch-labs/design-system'
import {
  StoryblokTable,
  StoryData,
  useStoryblokState,
} from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { Table } from '@cinch-nx/landing-ui-shared'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared'
import { Head } from '@cinch-nx/landing-ui-shared'

import { Wrapper } from '@cinch-nx/shared-ui'

import { storyblokComponents } from './data/storyblok-renderer-map'
import styles from './landing-feature-policy-pages.module.css'
import { PolicyPageStoryContent } from './types/policy-page'
import { PolicyPageFeatureProps } from './get-static-props'

const shouldRenderTable = (table: StoryblokTable): boolean =>
  table?.fieldtype === 'table' &&
  table?.tbody.length > 0 &&
  table.tbody?.[0].body?.[0]?.value !== ' '

export function PolicyPageFeature({ story, preview }: PolicyPageFeatureProps) {
  const typedStory = story as StoryData<PolicyPageStoryContent> & {
    rels: unknown[]
  }
  const { content } = useStoryblokState({
    story: typedStory,
    enableBridge: preview,
  })

  const typedContent = content as PolicyPageStoryContent

  const SEO = typedContent?.['SEO']?.[0]
  return (
    <>
      <Head
        {...SEO}
        fallbackTitle={story?.slug ? story?.slug : 'Cinch Used Cars Article'}
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />
      <Wrapper
        className={{ inner: styles.container }}
        data-testid="feature-policy-page-wrapper"
      >
        {typedContent && (
          <>
            <Heading element="h1" className={styles.title} fontSize="h1">
              {typedContent.title}
            </Heading>
            <ContentSection
              classNames={{
                body: 'storyblokRichTextBody',
              }}
            >
              {renderWithResolver(typedContent.body, { makeId: true })}
            </ContentSection>

            {typedContent.table && shouldRenderTable(typedContent.table) && (
              <Table {...typedContent.table} />
            )}
            {typedContent.widestRangeClaimTable &&
              shouldRenderTable(typedContent.widestRangeClaimTable?.table) && (
                <Table {...typedContent.widestRangeClaimTable?.table} />
              )}
            {typedContent.clauses && (
              <StoryblokRenderer
                block={typedContent.clauses}
                components={storyblokComponents}
              />
            )}
            {typedContent.cookiePolicy && (
              <StoryblokRenderer
                block={typedContent.cookiePolicy}
                components={storyblokComponents}
              />
            )}
          </>
        )}
      </Wrapper>
    </>
  )
}

export default PolicyPageFeature
